import { styled, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const StyledTextField = styled(TextField)({
    width: '100%',

    '& .MuiInputBase-input': {
        fontSize: '0.65rem'
    },

    '& .MuiFilledInput-root': {
        height: 30,
        paddingBottom: 15
    },

    '& .MuiInputLabel-root': {
        transform: 'translate(12px, -15px) scale(0.75)'
    }
});

const TextFieldComponent = ({ disabled, input, label, meta, ...rest }) => {
    return (
        <StyledTextField
            {...rest}
            autoComplete="off"
            disabled={disabled}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            inputProps={input}
            label={label}
            margin="normal"
            type="number"
            variant="filled"
        />
    );
};

TextFieldComponent.propTypes = {
    disabled: PropTypes.bool,
    input: PropTypes.object.isRequired, // Injected by Redux Forms
    label: PropTypes.string,
    meta: PropTypes.object // Injected by Redux Forms
};

export default TextFieldComponent;
